import React from 'react'
import styled from 'styled-components'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import { Button } from '@streamr/streamr-layout'
import RoundedBox from '../RoundedBox'
import tokenomics from './assets/tokenomics.png'
import tokenomics2x from './assets/tokenomics@2x.png'
import Topic from '~shared/Topic'
import Link from '~shared/Link'
import urls from '~utils/urls'

const IconContainer = styled.div`
    position: relative;
    width: 200px;
    height: 200px;

    img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-65%, -50%);
        width: 100%;
    }

    @media (min-width: ${TABLET}px) {
        width: 262px;
        height: 262px;

        img {
            transform: translate(-50%, -50%);
        }
    }

    @media (min-width: ${DESKTOP}px) {
        width: 360px;
        height: 360px;
    }
`

const Tokenomics = () => (
    <RoundedBox $appear>
        <RoundedBox.Inner>
            <RoundedBox.Content>
                <Topic.Title>
                    Tokenomics
                </Topic.Title>
                <Topic.Paragraph>
                    The Network can operate as a free and open data network,
                    but it also provides incentives for users to run paid nodes
                    to provide higher levels of service, and allows token holders
                    to earn yield by staking on nodes to share in their earnings.
                </Topic.Paragraph>
                <Button
                    tag={Link}
                    kind="primary"
                    size="big"
                    href={urls.discover.dataToken}
                    outline
                    noDecoration
                    noHover
                >
                    Explore tokenomics
                </Button>
            </RoundedBox.Content>
            <RoundedBox.Icon>
                <IconContainer>
                    <img src={tokenomics} srcSet={tokenomics2x} alt="" />
                </IconContainer>
            </RoundedBox.Icon>
        </RoundedBox.Inner>
    </RoundedBox>
)

export default Tokenomics
